module.exports = {"510182001":"天彭街道","510182101":"龙门山镇","510182102":"新兴镇","510182103":"丽春镇","510182104":"九尺镇","510182105":"濛阳镇","510182106":"通济镇","510182107":"丹景山镇","510182108":"隆丰镇","510182109":"敖平镇","510182110":"磁峰镇","510182111":"桂花镇","510182113":"军乐镇","510182114":"三界镇","510182116":"小鱼洞镇","510182118":"红岩镇","510182120":"升平镇","510182121":"白鹿镇","510182123":"葛仙山镇","510182126":"致和镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510182.json
// module id = 2271
// module chunks = 0